import { useDispatch, useSelector } from 'react-redux';
import { setIsEmbedded, setData, loadEmbedded } from './embedded.slice';

const useEmbedded = () => {
  const dispatch = useDispatch();

  const {
    isEmbedded,
    data: { appToken },
  } = useSelector((state) => state.embedded);

  const setEmbedded = (value) => {
    dispatch(setIsEmbedded(value));
  };

  const setEmbeddedData = (data) => {
    dispatch(setData(data));
  };

  const loadEmbeddedData = (data) => {
    dispatch(loadEmbedded(data));
  };

  return {
    setEmbeddedData,
    setEmbedded,
    loadEmbeddedData,
    appToken,
    isEmbedded,
  };
};

export default useEmbedded;
